import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";
import { ArrowUpRight, Lightning, Waveform, GearSix, Toolbox, PlugCharging, Fire, Warning } from "@phosphor-icons/react";
import { CATEGORIES, PRODUCTS } from "@/data/products";

const ICONS = {
  cables: Waveform,
  transformers: Lightning,
  switchgear: GearSix,
  motors: PlugCharging,
  conduit: Toolbox,
  transfer: Fire,
  devices: Warning,
};

export default function InventoryPreview() {
  return (
    <section
      id="inventory"
      className="relative bg-background border-b border-white/10 py-24 md:py-40"
      data-testid="inventory-preview"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-3xl">
            <span className="mono-label text-primary">/ Shop</span>
            <h2 className="mt-6 font-display font-black uppercase tracking-tighter text-5xl md:text-7xl lg:text-8xl leading-[0.85]">
              Order
              <br />
              from the
              <br />
              <span className="text-primary">catalog</span>.
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-foreground/60 mb-6 leading-relaxed">
              {PRODUCTS.length}+ SKUs in stock — cables, transformers, switchgear,
              motors, conduit, transfer switches and safety devices. Priced, ready to
              ship from Pendleton, SC.
            </p>
            <Link
              to="/inventory"
              className="inline-flex items-center gap-3 bg-primary text-primary-foreground px-6 py-4 mono-label hover:bg-foreground hover:text-background transition-colors"
              data-testid="preview-cta-inventory"
            >
              Use Our Inventory
              <ArrowUpRight size={16} weight="bold" />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {CATEGORIES.map((c, i) => {
            const Icon = ICONS[c.id] || Toolbox;
            const n = PRODUCTS.filter((p) => p.category === c.id).length;
            return (
              <Reveal
                key={c.id}
                delay={i * 0.05}
                className="border-b border-r border-white/10 p-6 md:p-8 group hover:bg-secondary/40 transition-colors"
              >
                <Link
                  to="/inventory"
                  className="flex flex-col justify-between h-full min-h-[180px]"
                  data-testid={`preview-cat-${c.id}`}
                >
                  <div className="flex items-start justify-between">
                    <Icon
                      size={32}
                      weight="light"
                      className="text-foreground/70 group-hover:text-primary transition-colors"
                    />
                    <span className="font-mono-tech text-xs text-muted-foreground">
                      {n} SKUs
                    </span>
                  </div>
                  <div className="mt-6 flex items-end justify-between">
                    <h3 className="font-display font-bold uppercase tracking-tight text-sm md:text-base leading-tight max-w-[80%]">
                      {c.label}
                    </h3>
                    <ArrowUpRight
                      size={20}
                      weight="bold"
                      className="text-muted-foreground group-hover:text-primary group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                    />
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
